module.exports = __webpack_public_path__ + "static/alltaggies-0056ba6547a6a63f159d3dc181564c4f.jpeg";